import { WretcherError } from 'wretch';
import { ToastOptions } from 'react-toastify';
import { put } from 'redux-saga/effects';
import { Socket, io } from 'socket.io-client';

import { IServerError, handleServerError } from '@crm-framework/utils';

import { chatActions } from '../store';
import { RTCClient } from '../call/RTCClient';

export function* handleChatError(
  error: IServerError | Error | string | WretcherError,
  isClientCheck: boolean = false,
  options?: ToastOptions
) {
  if ((error as WretcherError).status === 403) {
    if (!isClientCheck) yield put(chatActions.disable());
  } else {
    handleServerError(error, options);
  }
}
let rtcClient: RTCClient | null;
let socket: Socket | null;

export const getRtcClient = (): RTCClient => {
  if (!rtcClient) rtcClient = new RTCClient();

  return rtcClient;
};
export const getSocket = (token: string | null = null): Socket => {
  if (!socket)
    socket = io({
      reconnectionDelay: 10000000,
      transports: ['websocket'],
      path: '/api/xchat/socket',
      auth: {
        token,
      },
    });

  return socket;
};

export const removeRtcClient = (): void => {
  rtcClient = null;
};
